import { cn } from '@/shared/utils/cn';
import { FieldError } from './FieldError';

type FormFieldProps = {
  label: string;
  htmlFor: string;
  error?: string;
  required?: boolean;
  hint?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
};

export function FormField({
  label,
  htmlFor,
  error,
  required,
  hint,
  children,
  className,
}: FormFieldProps) {
  const errorId = `${htmlFor}-error`;

  return (
    <div className={cn('flex flex-col gap-1', className)}>
      <label
        htmlFor={htmlFor}
        className="text-sm font-medium text-adipa-text-primary"
      >
        {label}
        {required && (
          <span aria-hidden="true" className="ml-0.5 text-adipa-error">
            *
          </span>
        )}
      </label>
      {hint && <p className="mb-1 text-xs text-adipa-text-secondary">{hint}</p>}
      {children}
      <FieldError id={errorId} message={error} />
    </div>
  );
}
